import { setLightness } from "polished";
import styled, { css } from "styled-components";
import theme from "../front/style/theme";
import { TextIcon, Wait } from "../front/choir/pages/dashboard/Choir/ChoirUpperRow/styles";

const $color2 = (p: { theme: typeof theme }) => setLightness(0.28, p.theme.c.dark);
const $lineHeight = 1;
const $lineDistance = 7;
const $systemDistance = 20;

export const staffLines = css`
    background-image: repeating-linear-gradient(
        0deg,
        ${$color2},
        ${$color2} ${$lineHeight}px,
        ${p => p.theme.c.dark} ${$lineHeight}px,
        ${p => p.theme.c.dark} ${$lineHeight * 1 + $lineDistance * 1}px,
        ${$color2} ${$lineHeight * 1 + $lineDistance * 1}px,
        ${$color2} ${$lineHeight * 2 + $lineDistance * 1}px,
        ${p => p.theme.c.dark} ${$lineHeight * 2 + $lineDistance * 1}px,
        ${p => p.theme.c.dark} ${$lineHeight * 2 + $lineDistance * 2}px,
        ${$color2} ${$lineHeight * 2 + $lineDistance * 2}px,
        ${$color2} ${$lineHeight * 3 + $lineDistance * 2}px,
        ${p => p.theme.c.dark} ${$lineHeight * 3 + $lineDistance * 2}px,
        ${p => p.theme.c.dark} ${$lineHeight * 3 + $lineDistance * 3}px,
        ${$color2} ${$lineHeight * 3 + $lineDistance * 3}px,
        ${$color2} ${$lineHeight * 4 + $lineDistance * 3}px,
        ${p => p.theme.c.dark} ${$lineHeight * 4 + $lineDistance * 3}px,
        ${p => p.theme.c.dark} ${$lineHeight * 4 + $lineDistance * 4}px,
        ${$color2} ${$lineHeight * 4 + $lineDistance * 4}px,
        ${$color2} ${$lineHeight * 5 + $lineDistance * 4}px,
        ${p => p.theme.c.dark} ${$lineHeight * 5 + $lineDistance * 4}px,
        ${p => p.theme.c.dark} ${$lineHeight * 5 + $lineDistance * 5 + $systemDistance}px
    );
`;

export const PublishButton = styled.button`
    display: inline-block;
    cursor: pointer;
    background-color: transparent;
    border: none;
    outline: none;
    padding: 0;
    margin-top: 4px;

    [class^="i-"], ${TextIcon}, svg {
        :not(${Wait} [class^="i-"]) {
            width: 50px;
            height: 50px;
            font-size: 50px;
            display: block;
            transition: 300ms;
            color: ${p => p.theme.c.grey9};
        }
    }

    .i-homework {
        font-size: 42px;
        padding-top: 4px;
        margin-bottom: -4px;
    }

    .i-duplicate {
        font-size: 40px;
        width: 40px;
        margin: 0 2px;
        position: relative;
        top: 6px;
    }

    [class*="Alert"] {
        transition: 300ms;
        top: 36px;
        left: 30px;
        transform-origin: -6px -6px;
    }

    &:hover {
        svg,
        [class^="i-"],
        [class*="Alert"],
        ${TextIcon} {
            transform: scale(1.2);
        }
    }

    &:disabled {
        [class^="i-"],
        ${TextIcon} {
            transform: scale(1);
        }
        cursor: default;
        opacity: 0.3;
    }

    &.Active {
        [class^="i-"],
        ${TextIcon} {
            :not(${Wait} [class^="i-"]) {
                color: ${p => p.theme.c.boost};
            }
        }
    }

    &.Completed {
        [class^="i-"],
        ${TextIcon} {
            :not(${Wait} [class^="i-"]) {
                color: ${p => p.theme.c.correct};
            }
        }
    }
`;
